// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const shadows = {
    deepMulti: "0px 6px 6px rgba(0, 0, 0, 0.17)",
    deep: "6px 6px 4px rgba(0, 0, 0, 0.25)",
    medium: "4px 4px 4px rgba(0, 0, 0, 0.2)",
    soft: "2px 2px 4px rgba(0, 0, 0, 0.15)",
};
module.exports = shadows;
//# sourceMappingURL=shadows.js.map